export default ({ fill = "#111928", size = "18" }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 18 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M5.31563 1.72358C5.41875 1.68216 5.53125 1.67579 5.6375 1.70765L12.4719 3.69892L16.9719 1.86377C17.4656 1.66304 18 2.03263 18 2.57425V13.2411C18 13.5533 17.8125 13.8337 17.5281 13.9516L12.6844 15.9269C12.5812 15.9683 12.4688 15.9747 12.3625 15.9429L5.52812 13.9516L1.02813 15.7867C0.534375 15.9875 0 15.6179 0 15.0763V4.40941C0 4.09718 0.1875 3.8168 0.471875 3.69892L5.31563 1.72358ZM1 4.58145V14.7003L5 13.0691V2.9502L1 4.58145ZM12 14.7768V4.62287L6 2.87374V13.0276L12 14.7768ZM13 14.7003L17 13.0691V2.9502L13 4.58145V14.7003Z"
      fill={fill}
    />
  </svg>
);
